import React from "react";
import Chip from "@material-ui/core/Chip";
import SvgIcon from "@material-ui/core/SvgIcon";

import {
	FaLock,
	FaSmileBeam,
	FaPaintBrush,
	FaPenAlt,
	FaHandHoldingUsd,
	FaPrint,
	FaIdBadge,
	FaTshirt,
	FaGift,
	FaBookOpen,
	FaPaw,
	FaDog,
	FaMusic,
	FaEllipsisH,
} from "react-icons/fa";

const TAG_ICON_MAP = {
	NSFW: FaLock, // FaMask
	SFW: FaSmileBeam,
	Traditional: FaPaintBrush,
	Digital: FaPenAlt,
	Commissions: FaHandHoldingUsd,
	Prints: FaPrint,
	YCH: FaIdBadge,
	Clothing: FaTshirt,
	Accessories: FaGift,
	"Books/Comics/Zines": FaBookOpen,
	"Fursuits/Fursuit parts": FaPaw,
	"Sculptures/Plushies/Dolls": FaDog,
	Music: FaMusic,
	Misc: FaEllipsisH,
};
export default ({ tag, ...rest }) => (
	<Chip
		{...rest}
		icon={
			<SvgIcon
				component={TAG_ICON_MAP[tag]}
				viewBox="-100 -100 700 700"
			/>
		}
		label={tag}
	/>
);
